import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";

import useStyles from "./styles/MobileViewStyles";
import { fundRaiserPageAction } from "../../../../store/actions";
import { UpdatesAndCommentsSkeleton } from "../../../../components/skeletons";
import { ContentWithHeading, LongText, MixPanelTrackedLink } from "../../../../components";
import { Box, Divider, Typography } from "@mui/material";

export function MobileView() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);
    const pageMessages = useSelector(state => state.fundraiser_page.pageMessages);
    // const user = useSelector(state => state.authentication.user);

    const [state, setState] = useState({
        offset: 0,
        limit: 6
    });
    const [loadingMessages, setLoadingMessages] = useState(false);
    const [totalMessages, setTotalMessages] = useState(0);
    const [goodLuckMessages, setGoodLuckMessages] = useState([]);

    // const isOwner = pageDetails.user_id == user.id;
    // const ownerName = pageDetails.first_name + " " + pageDetails.last_name;

    const updateOffset = () => {
        setState({
            ...state,
            offset: state.offset + state.limit
        });
    }
    const loadMoreMessages = async () => {
        setLoadingMessages(true);
        const payload = {
            fundraiser_page_id: pageDetails.id,
            offset: state.offset,
            limit: state.limit
        }
        await dispatch(fundRaiserPageAction.getGoodLuckMessages(payload));
        setLoadingMessages(false);
    }

    // useEffect(() => {
    //     dispatch(fundRaiserPageAction.getFundRaiserPageUpdates({fundraiser_page_id: pageDetails.id}));
    // }, [pageDetails]);

    useEffect(() => {
        if (state.offset > 0) {
            loadMoreMessages()
        }
    }, [state.offset]);

    useEffect(() => {
        if (pageMessages) {
            setTotalMessages(pageMessages.total);
            setGoodLuckMessages(pageMessages.messages);
        }
    }, [pageMessages, pageMessages.messages])

    return pageMessages.total ? <ContentWithHeading _className={classes.messagesSection} heading={`Words of Encouragement (${pageMessages.total || 0})`}>
        <div>
            {
                goodLuckMessages ? goodLuckMessages.map(message => {
                    return <React.Fragment>
                        <Box sx={{ mb: 2 }}>
                            <Typography sx={{ fontWeight: 600 }} >{message.donor_name}</Typography>
                            <Typography sx={{ fontSize: '14px' }} gutterBottom>{message.donation_amount} - <Typography sx={{ fontSize: '14px' }} component="span" color="neutral.dark">{message.created_date}</Typography></Typography>
                            <LongText content={message.good_luck_message} limit={250} />
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                    </React.Fragment>
                })
                    :
                    <UpdatesAndCommentsSkeleton />
            }
            <div className={classes.buttonContainer}>
                {goodLuckMessages &&
                    goodLuckMessages.length < totalMessages &&
                    <MixPanelTrackedLink
                        type="button"
                        label="Show Older"
                        context="Show older comments"
                        variant="outlined"
                        onClick={updateOffset}
                    >
                        {loadingMessages ? <CircularProgress size={25} /> : 'Show Older'}
                    </MixPanelTrackedLink>}
            </div>
        </div>
    </ContentWithHeading> : null
}